module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/arrow_left.svg";